var map = {
	"./config-default": "KuON",
	"./config-default.js": "KuON",
	"./config-development": "3WTL",
	"./config-development.js": "3WTL",
	"./config-local": "zAGS",
	"./config-local.js": "zAGS",
	"./config-production": "Q61S",
	"./config-production.js": "Q61S",
	"./config-staging": "III3",
	"./config-staging.js": "III3",
	"./config-testing": "HPNT",
	"./config-testing.js": "HPNT"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "VktM";